"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHotelMapNoCoords = function SvgHotelMapNoCoords(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 112 84"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hotel-map-no-coords_svg__a",
    d: "M30.464 45.764c0 3.204.686 6.264 2.037 9.094C38.326 67.047 53.382 84 53.76 84c.377 0 15.432-16.952 21.259-29.142 1.352-2.83 2.037-5.89 2.037-9.094-.001-12.285-10.452-22.28-23.297-22.28-12.844 0-23.295 9.995-23.295 22.28z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "hotel-map-no-coords_svg__b",
    width: 46.592,
    height: 60.516,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hotel-map-no-coords_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1F3FF",
    d: "M66.288 28.756c5.943 3.753 9.871 10.189 9.872 17.484 0 3.013-.646 5.89-1.92 8.551-5.49 11.463-19.677 27.403-20.032 27.403-.084 0-.934-.884-2.257-2.384 2.455-2.5 14.615-16.605 19.601-27.015 1.274-2.662 1.92-5.538 1.92-8.552 0-6.122-2.767-11.64-7.17-15.473z"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#C2C5CC",
    strokeDasharray: 2.258,
    strokeLinejoin: "round",
    strokeWidth: 2.258,
    mask: "url(#hotel-map-no-coords_svg__b)",
    xlinkHref: "#hotel-map-no-coords_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "m8.96 35.226-5.267 2.79 1.006-5.91-4.26-4.187 5.888-.863 2.633-5.379 2.633 5.38 5.888.862-4.26 4.186 1.006 5.912zm90.496-15.754-7.753 4.012 1.481-8.497-6.272-6.017 8.668-1.24L99.456 0l3.876 7.73L112 8.97l-6.272 6.017 1.48 8.497zM90.944 68.6l-3.6 1.852.688-3.922-2.912-2.777 4.024-.572 1.8-3.568 1.8 3.568 4.024.572-2.912 2.777.687 3.922z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.216 41.548)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.792,
    cy: 1.806,
    fill: "#17181A",
    rx: 1.792,
    ry: 1.806
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.296,
    cy: 1.806,
    fill: "#17181A",
    rx: 1.792,
    ry: 1.806
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#17181A",
    strokeWidth: 0.9,
    d: "M3.584 12.645c6.374-2.408 12.646-2.408 18.816 0"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHotelMapNoCoords);
var _default = exports["default"] = Memo;